class Progress {
  constructor() {
    this.progresses = {
      1: [],
      2: []
    }
    this.type = {
      STOP: 1,
      PLAY: 2
    }
  }
  async create(type = 0) {
    const promise = {
      resolve: null,
      reject: null,
      done: null,
      isResolved: false,
      isPending: false,
      type: null,
      waiter: null,
      terminate: () => {}
    }

    promise.type = type
    promise.done = new Promise((res, rej) => {
      promise.resolve = data => {
        if (promise.isResolved) return

        promise.isResolved = true
        if (type) _$.progress.remove(promise)
        res(data || true)
        return true
      }
      promise.reject = data => {
        if (promise.isResolved) return

        promise.isResolved = true
        if (type) _$.progress.remove(promise)

        rej(false)
        if (data) _$.error(data)
        return false
      }
    }).catch(err => _$.error(err))

    promise.terminateAfter = (timeout = 5000) => {
      setTimeout(() => {
        if (promise.isResolved) return

        promise.reject()

        _$.log("Request timeout!")
        _$.vue.$emit("mediaError", { type: "mediaError" })
      }, timeout)
    }

    if (type === 0) return promise

    const queue = this.progresses[type]
    promise.waiter = queue.pop()

    queue.push(promise)

    if (promise.waiter && promise.waiter.waiter && promise.waiter.waiter.isPending && type === this.type.PLAY) {
      promise.waiter.reject(false)
      promise.waiter = promise.waiter.waiter
    }

    if (promise.waiter) await promise.waiter.done

    promise.isPending = true

    return promise
  }
  async abortMediaRequest() {
    if (!this.progresses[2].length) return true
    const activePlay = this.progresses[2].shift()

    this.progresses[2].forEach(promise => promise.reject(false))

    let waiter
    if (activePlay.waiter && !activePlay.waiter.isResolved) {
      waiter = activePlay.waiter
      activePlay.reject(false)
    } else waiter = activePlay

    return waiter.done
  }
  hasMediaRequest() {
    if (this.progresses[2].length || this.progresses[1].length) return true
    return false
  }
  remove(promise) {
    const index = this.progresses[promise.type].indexOf(promise)
    index > -1 && this.progresses[promise.type].splice(index, 1)
  }
}
export default new Progress()
